<template>
  <!-- TODO: maybe there's an opportunity for some component abstraction here -->
  <main id="app" @keydown="handleKeyPress" tabindex="0" :class="mainClasses">
    <div v-if="error" class="error">
      <h2>Sorry, error retrieving puzzle</h2>
      <p>Please check the URL and internet connection try again.</p>
    </div>

    <div v-else-if="!quotes.length && !showTheEnding && played === 0" class="container loading">
      <p>Loading game… <i class="spinner"></i></p>
    </div>

    <div v-else-if="showTheEnding" class="container">
      <h1>The end</h1>
      <p>You won {{ won }} of {{ played }} puzzles!</p>

      <button id="new-game" @click="nextPuzzle" :class="{'highlight': puzzleOver}">
        Play Again?
      </button>
    </div>

    <div v-else class="container">
      <p id="quote" :class="{ 'strike': strikeout, 'highlight': puzzleComplete }">
        <span class="game-status" v-if="totalQuotes > 1">
          Puzzle {{ played }} of {{ totalQuotes }}
        </span>
        <span v-for="(word, index) in splitQuote" :key="word + index">
          <template v-for="letter in word">{{ isRevealed(letter) }}</template>
        </span>
      </p>

      <p v-if="hint" class="hint">{{ hint }}</p>

      <div class="status">
          <h2>Strikes:</h2>
          <ul class="status">
            <li v-for="(strike, index) in strikes" :key="index">
              {{ strike.icon }}
            </li>
          </ul>
      </div>

      <div id="button-board">
        <button
          v-for="letter in letters"
          :key="letter"
          @click="guess(letter)"
          :class="{'strike': badGuesses.includes(letter), 'highlight': guesses.includes(letter)}"
          :disabled="guesses.includes(letter) || puzzleOver"
        >
          <kbd class="letter" :class="{'riser': guesses.includes(letter)}">{{ letter }}</kbd>
          <span class="background"></span>
        </button>
      </div>

      <div class="status">
        <p>{{ message }}</p>
      </div>

      <button id="new-game" ref="newGameButton" @click="nextPuzzle" :class="{'highlight': puzzleOver}">
        Next
      </button>
    </div>
  </main>
</template>

<script>
import fireEmAll from './assets/js/confetti'

const defaultState = {
  letters: Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
  quotes: [],
  currentQuote: '',
  guesses: [],
  strikes: [],
  puzzleOver: false,
  error: false,
  game: null,
  played: 0,
  won: 0,
  showTheEnding: false,
}

export default {
  name: 'Hangman',

  data: () => ({
		...defaultState
	}),

	mounted() {
		this.makeApiCall()
	},

	methods: {
    makeApiCall() {
      Object.assign(this.$data, defaultState)
      this.guesses = []
      this.strikes = []
      this.quotes = []
      this.getAndHandleQueryParameters()

      if (! this.game ) {
        this.error = true
      }

      fetch(`https://courses.howcanisay.com.br/wp-json/wp/v2/hangman_games/${this.game}`)
        .then((response) => response.json())
        .then((fetchedQuotes) => {
          const solutions = fetchedQuotes.acf.possible_solutions.map(obj => {
            return {
              text: obj.solution.match(/^<span>(.*)<\/span>$/).pop(),
              hint: obj.hint ? obj.hint.match(/^<span>(.*)<\/span>$/).pop() : null
            }
          })

          this.quotes = solutions;
          this.setTheQuote()
        })
        .catch((error) => {
          console.error(error)
          this.error = error;
        })
    },

    getAndHandleQueryParameters() {
      const queryString = location.search
      const params = new URLSearchParams(queryString)
      const customStrikes = params.get('strikes')
      const gameToPlay = params.get('game')
      const hint = params.get('hint')

      const allowedStrikes = customStrikes ? parseInt(customStrikes) : 5

      this.strikes = new Array(allowedStrikes).fill({ icon: '⚪', guess: '' })
      this.game = gameToPlay
      this.hint = hint
    },

		//Can enter guesses with a keyboard, but it doesn't work super great because you need to be focusing a non-disabled element to use it currently. Needs some refinement.
		handleKeyPress(e) {
			const key = e.key.toUpperCase()
			if (key.length === 1 && key.match(/[a-zA-Z]/) && !this.guesses.includes(key)) {
				this.guess(key)
			}

      if (key === 'ENTER' && e.target !== this.$refs.newGameButton) {
        this.nextPuzzle()
      }
		},

		setTheQuote() {
      if (this.quotes.length && this.played < this.totalQuotes) {
        const random = Math.floor(Math.random() * this.quotes.length)
        const chosenQuote = this.quotes[random]
        console.log(chosenQuote.text)
        this.quotes.splice(random, 1)
        this.played ? this.played += 1 : this.played = 1;
        this.currentQuote = chosenQuote.text.toUpperCase()
        this.hint = chosenQuote.hint
      } else {
        this.showTheEnding = true;
        this.currentQuote = ""

        if (this.won > 1) {
          fireEmAll()
        }

        return
      }

		},

    isRevealed(letter) {
			if (!letter.match(/[a-zA-Z\s]/)) {
				return letter
			}
			return this.guesses.includes(letter) || this.puzzleOver ? letter : '_'
		},

		guess(letter) {
			this.guesses.push(letter)
			if (!this.currentQuote.includes(letter)) {
				this.strikes.pop()
				this.strikes = [{ icon: '🚫', guess: letter }, ...this.strikes]
			}
			if (this.strikeout || this.puzzleComplete) {
				this.puzzleOver = true
			}
		},

		nextPuzzle() {
      if (!this.puzzleOver && !this.showTheEnding) {
        const confirmation = confirm('Skip this puzzle and start the next one?')
        if (!confirmation) return
      }

      if (this.showTheEnding) {
        const confirmation = confirm('Start this game over?')
        if (confirmation) {
          this.makeApiCall()
        }
        return
      }

      if (!this.strikeout && this.puzzleComplete) {
        this.won += 1;
      }

			this.setTheQuote()
			this.guesses = []
      this.strikes = this.strikes.map(() => ({ icon: '⚪', guess: '' }))
			this.puzzleOver = false
		}
	},

	computed: {
		splitQuote() {
			return this.currentQuote.split(' ')
		},

		badGuesses() {
			return this.strikes.filter(s => s.guess).map(s => s.guess)
		},

		strikeout() {
			return this.badGuesses.length >= this.strikes.length
		},

		puzzleComplete() {
			return this.unrevealed === 0
		},

		unrevealed() {
			return [...this.currentQuote].filter(letter => {
				return letter.match(/[a-zA-Z]/) && !this.guesses.includes(letter)
			}).length
		},

    totalQuotes() {
      if ((this.quotes.length + this.played) > 15) {
        return 15
      }

      return (this.quotes.length + this.played)
    },

		message() {
			if (!this.puzzleOver) {
				return '☝️ Pick a letter'
			} else if (this.strikeout) {
				return '❌ Struck out.'
			} else if (this.puzzleComplete) {
				return '🎉 Good job! 🎉'
			}
			//You can never be too safe ¯\_(ツ)_/¯
			return '😬 Unforeseen error state, maybe try a new game?'
		},

		mainClasses() {
			let classes = []
			if (this.strikeout) {
				classes.push('strikeout')
			}
			return classes
		}
	}
}
</script>

<style lang="scss">
// TODO: most of this should probably be global
$lighterGray: #d7dade;
$lightGray: #a7a8aa;
$darkGray: #53565a;
$mediumGray: #888b8d;
$black: #101820;
$white: #fff;
$yellow: #ffd100;
$orange: #ff6a13;
$red: #e4002b;
$lightBlue: #7ba7bc;
$lighterBlue: lighten($lightBlue, 30%);
$darkBlue: #34657f;

$easing: cubic-bezier(0.5, 0, 0.5, 1);
$breakpoint: 600px;

*,
*:before,
*:after {
	box-sizing: border-box;
}

*:focus {
	outline: 2px solid $lightBlue;
  outline-offset: -2px;
	box-shadow: 0 0 0 4px $yellow;
}

html {
	font-size: calc(1em + 1vw);
	line-height: 1.5;

	@media(min-width: 1200px) {
		font-size: 1.375em;
	}
}

body {
	margin: 0;
	min-height: 100vh;
	font-size: 1.5em;
	font-family: "Rubik Mono One", "Pathway Gothic One";
	color: $darkGray;
	background: lighten($lightBlue, 35%);
}

#app {
  min-height: 100vh;

	&.strikeout {
		animation: flash_red 1s linear forwards;
	}
}

.error {
	padding: 1rem;

	h2, p {
		line-height: 1;
	}
}

.container {
	width: 100%;
	max-width: 36rem;
	margin: auto;
	padding: 1rem;

  &.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }

	@media(min-width: $breakpoint) {
		padding: 2rem;
	}
}

#quote {
  position: relative;
	letter-spacing: 0.1em;
	margin: 0 0 0.5em;
	font-size: 1.25rem;
	line-height: 1.2em;
	background: $lighterBlue;
	border: 2px solid $darkGray;
	padding: 1rem 1rem 2rem;
	box-shadow: 4px 4px 0 0 $lightBlue;
	position: relative;

	@media(min-width: $breakpoint) {
		font-size: calc(1rem + 1vw);
		margin: 1em 0 .5em;
		padding: 2rem;
	}

	&.strike {
		color: $lighterGray;
		background-color: $red;
	}

	&.highlight {
		background-color: $yellow;
		animation: tada .5s ease-in-out forwards;
	}

	span {
		margin-right: 0.75em;
		display: inline-block;
	}

	small {
		font-size: .5em;
		position: absolute;
		bottom: 0.5em;
		left: 2em;
	}
}

#button-board {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(1.5em, 1fr));
	grid-gap: 0.5rem;

	@media (min-width: $breakpoint) {
		grid-template-columns: repeat(auto-fit, minmax(2em, 1fr));
	}
}

button {
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: inherit;
	padding: 0.4em .5em 0.3em .5em;
	width: auto;
	line-height: 1;
	border: 2px solid $darkGray;
	color: inherit;
	background: $lighterBlue;
	font-size: .75em;
	box-shadow: 4px 4px 0 0 $lightBlue;
	position: relative;
	overflow: hidden;
	transform-origin: bottom right;

	@media(min-width: $breakpoint) {
		font-size: 1em;
	}

	.background {
		content: '';
		height: 100%;
		width: 100%;
		background: $yellow;
		position: absolute;
		z-index: 0;
		bottom: 0;
		left: 0;
		transform: scaleY(0);
		transform-origin: bottom;
		transition: transform .2s cubic-bezier(.75, 0, .25, 1);
	}

	&:hover:not(:active):not([disabled]),
	&:focus:not(:active):not([disabled]) {
		transform: translate(-1px, -1px);
		box-shadow: 6px 6px 0 0 $lightBlue;
	}

	&:not([disabled]):active {
		transform: translate(2px, 2px);
		box-shadow: 0 0 0 0 $lightBlue;
	}

	&.highlight .background {
		transform: scaleY(1);
	}

	&.strike {
		color: $lighterGray;
		.background {
			background-color: $red;
		}
	}

	&#new-game {
		margin-top: 1.5rem;

    @media(min-width: $breakpoint) {
      margin-top: 2rem;
    }
	}

	.letter {
		position: relative;
		z-index: 2;
		color: inherit;
		font-family: inherit;
	}

	&[disabled]:not(.highlight) {
		border-color: $lightGray;

		.letter {
			color: $lightGray;
		}
	}
}

.game-status {
  position: absolute;
  top: -.8rem;
  left: -8px;
  z-index: 2;
  font-size: .7rem;
  background: $yellow;
  padding: .5em;
  border: 2px solid;
  line-height: 1;
  color: $darkGray;
}

.status {
	display: flex;
	flex-wrap: wrap;
	list-style-type: none;
  line-height: 1;
	align-items: center;
  margin: 1rem 0 0.5rem;

	h2 {
		font-size: .9rem;
		margin: 0;
	}

	ul {
		display: flex;
		margin: 0;
		padding: 0;

		li {
			margin-left: 0.25em;
		}
	}

	p {
		font-size: 1rem;
		width: 100%;
		margin: 0;
	}
}

.riser {
	animation: rise .3s $easing;
	display: block;
}

.hint {
  font-size: .85rem;
  margin: 0 0 1.5rem;
  padding: 0;
  line-height: 1.2;
	color: $darkBlue;

  @media(min-width: $breakpoint) {
		font-size: 1rem;
	}
}

.spinner {
  width: 1em;
  height: 1em;
  display: inline-block;
  border: 4px solid;
  border-radius: 1em;
  border-top-color: transparent;
  animation: rotate 1.2s linear infinite;
}

@keyframes flash_red {
	0% {
		background: $red;
	}
	100% {
		background: transparent;
	}
}

@keyframes tada {
	0% {
		transform: scale(1);
	}
	20% {
		transform: scale(1.1);
	}
	40% {
		transform: scale(0.9);
	}
	60% {
		transform: scale(1.05);
	}
	80% {
		transform: scale(1);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes rise {
	0% {
		transform: translateY(0);
	}
	44.9% {
		transform: translateY(-1.5em);
	}
	45% {
		transform: translateY(1.5em);
	}
	55% {
		transform: translateY(1.5em);
	}
	0% {
		transform: translateY(0);
	}
}

</style>
